// Central site configuration for Culture Antique Jewellery.
// Contact details sourced from the brand NOTES (Ahmedabad).

export const brand = {
  name: "Culture Antique",
  legalName: "Culture Antique Jewellery Pvt. Ltd.",
  tagline: "Heritage Gold, Timeless Craft",
  logoBlack: "/assets/brand/logo-black.png", // for light backgrounds
  logoWhite: "/assets/brand/logo-white.png", // for dark backgrounds
};

export const nav = [
  { label: "The House", to: "/about" },
  { label: "Collections", to: "/collections" },
  { label: "The Lookbook", to: "/gallery" },
  { label: "Visit Us", to: "/contact" },
];

export const social = {
  instagram: "https://www.instagram.com/culture_antique_jewellery/",
  whatsapp: "https://wa.me/919904515405",
  maps: "https://www.google.com/maps/search/?api=1&query=Culture+Antique+Jewellery+405+Ten-11+Chimanlal+Girdharlal+Rd+Navrangpura+Ahmedabad",
};

export const contact = {
  phone: "+91 99045 15405",
  // No email was supplied in the brand notes — placeholder, please confirm.
  email: "info@cultureantique.com",
  addressLines: [
    "405, Ten-11, Nr. Chimanlal Girdharlal Rd,",
    "Navrangpura, Ahmedabad, Gujarat 380006",
  ],
  mapQuery:
    "Culture Antique Jewellery, 405 Ten-11, Chimanlal Girdharlal Rd, Navrangpura, Ahmedabad",
  hours: "Mon – Sat · 11:00 AM – 8:00 PM",
};

// Curated feature imagery (from the editorial lookbook).
export const feature = {
  heroHome: "/assets/lookbook/ms-153.jpg", // regal, jewellery-forward — temple necklace, jhumkas & bangles
  heroAbout: "/assets/lookbook/ms-030.jpg",
  heroCollections: "/assets/lookbook/ms-038.jpg",
  heroGallery: "/assets/lookbook/ms-047.jpg",
  heroContact: "/assets/lookbook/ms-091.jpg",
  legacy: "/assets/lookbook/ms-069.jpg",
  editorialDark: "/assets/lookbook/ms-107.jpg",
  cta: "/assets/lookbook/ms-108.jpg",
  showroom: "/assets/lookbook/ms-136.jpg", // placeholder — replace with real boutique photo
};

// Lookbook teaser tiles for the home "Muse" grid.
export const museGrid = [
  "/assets/lookbook/ms-014.jpg",
  "/assets/lookbook/ms-096.jpg",
  "/assets/lookbook/ms-069.jpg",
  "/assets/lookbook/ms-104.jpg",
  "/assets/lookbook/ms-022.jpg",
  "/assets/lookbook/ms-129.jpg",
];

export const collections = [
  {
    id: "antique-necklaces",
    name: "Antique Necklaces",
    blurb:
      "Hand-crafted gold necklaces in the timeless antique tradition — statement pieces made to be treasured.",
    image: "/assets/lookbook/ms-102.jpg", // long antique gold haram
  },
  {
    id: "bridal-heritage",
    name: "Bridal Heritage",
    blurb:
      "Regal bridal sets for the most cherished of occasions, designed to become family heirlooms.",
    image: "/assets/lookbook/ms-131.jpg", // full bridal look, regal
  },
  {
    id: "temple-kundan",
    name: "Temple & Kundan",
    blurb:
      "Intricate temple motifs and uncut kundan work, rooted in centuries of Indian craftsmanship.",
    image: "/assets/lookbook/ms-103.jpg", // temple choker + long necklace
  },
];

// Scrolling ribbon keywords beneath the hero.
export const ribbonWords = [
  "Kundan",
  "Polki",
  "Temple",
  "Jadau",
  "Meenakari",
  "22K Antique Gold",
  "Bridal Heritage",
  "Handcrafted in Ahmedabad",
];

// The Craft — storytelling trio (uses editorial close-ups).
export const crafts = [
  {
    id: "kundan",
    name: "Kundan",
    text: "Refined gold foil set around uncut stones — a courtly art perfected over centuries, laid by hand.",
    image: "/assets/lookbook/ms-058.jpg", // kundan choker — flat uncut stones + pearl fringe
  },
  {
    id: "temple",
    name: "Temple",
    text: "Motifs drawn from South Indian temple architecture, cast in 22K gold and worn as devotion.",
    image: "/assets/lookbook/ms-150.jpg", // temple haram with peacock pendant + kada
  },
  {
    id: "jadau",
    name: "Jadau & Polki",
    text: "Uncut diamonds embedded in molten gold — no adhesive, only mastery, the way it has always been done.",
    image: "/assets/lookbook/ms-039.jpg", // polki/jadau rani-haar + jhumka
  },
];

// Heritage marks — qualitative, honest hallmarks of the house.
export const heritageStats = [
  { value: "22K", label: "Hallmarked antique gold" },
  { value: "1 / 1", label: "Every design one of a kind" },
  { value: "100%", label: "Hand-finished in Ahmedabad" },
  { value: "∞", label: "Made to be passed down" },
];

// Client words — placeholder testimonials; replace with real client quotes.
export const testimonials = [
  {
    quote:
      "My bridal set felt like an heirloom the moment I wore it. Strangers still stop to ask where it is from.",
    name: "Ananya",
    place: "Ahmedabad",
  },
  {
    quote:
      "They understood exactly the antique look I wanted, and made it entirely my own. Nothing else compares.",
    name: "Meera",
    place: "Mumbai",
  },
  {
    quote:
      "The craftsmanship is extraordinary — you can feel the hours in every motif. A true keepsake.",
    name: "Ritu",
    place: "London",
  },
];

// Two rows for the lookbook marquee.
// Curated full-look portraits for the home "Lookbook" teaser grid.
export const lookbookMarquee = {
  top: [
    "/assets/lookbook/ms-131.jpg", // bridal, full set
    "/assets/lookbook/ms-017.jpg", // blue Banarasi, long haar
    "/assets/lookbook/ms-097.jpg", // red saree, heritage bench
    "/assets/lookbook/ms-103.jpg", // temple choker, direct gaze
    "/assets/lookbook/ms-030.jpg", // white saree, palace corridor
    "/assets/lookbook/ms-151.jpg", // blue saree, direct gaze
  ],
  bottom: [
    "/assets/lookbook/ms-102.jpg",
    "/assets/lookbook/ms-058.jpg",
    "/assets/lookbook/ms-150.jpg",
    "/assets/lookbook/ms-145.jpg",
    "/assets/lookbook/ms-085.jpg",
    "/assets/lookbook/ms-039.jpg",
  ],
};

// Import & Export — worldwide trade.
// NOTE: deliberately non-specific. If you want named markets listed
// (e.g. UK · USA · UAE · Australia), send the confirmed list and I'll add them.
export const tradePoints = [
  {
    id: "export",
    title: "Worldwide Export",
    text: "Hand-crafted antique gold shipped to private clients and retailers across the globe.",
  },
  {
    id: "trade",
    title: "Trade Partners",
    text: "Wholesale and bulk orders for jewellers and boutiques, crafted to your specification.",
  },
  {
    id: "secure",
    title: "Secure & Insured",
    text: "Every consignment is fully insured, discreetly packed and tracked to your door.",
  },
  {
    id: "custom",
    title: "Custom Commissions",
    text: "Bespoke designs made to order, with export documentation handled end to end.",
  },
];

export const features = [
  {
    title: "22K Antique Gold",
    text: "Purity you can trust — every piece is hallmarked and hand-finished in our Ahmedabad atelier.",
  },
  {
    title: "Heritage Craftsmanship",
    text: "Techniques passed down through generations of master karigars, kept alive in every creation.",
  },
  {
    title: "Bespoke Commissions",
    text: "Work with our designers to create a one-of-a-kind piece, made entirely to your vision.",
  },
  {
    title: "By-Appointment Viewings",
    text: "Discreet, unhurried consultations in an intimate setting at our Navrangpura showroom.",
  },
];
